export default {
  drawer: false,
  addCardDrawer: false,
  hasInitialData: false,
  showConfig: false,
  autoReload: false,
  forceRefresh: false,
  silentRefresh: false,
  showComponentBuildModal: false,
  previousDataLabel: '',
};
